// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

/* Added to prevent overscroll bounce */
html, body {
  overscroll-behavior: none;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* Optional: Additional classes for convenience */
.full-height {
  height: 100vh;
}

.no-overscroll {
  overscroll-behavior: none;
}

.no-overflow {
  overflow: hidden;
}

/* Existing styles */
.App {
  text-align: center;
}

.App-logo {
  animation: App-logo-spin infinite 20s linear;
  height: 40vmin;
  pointer-events: none;
}

/* You can uncomment and use these styles if needed */
/*
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}
*/

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.container-fluid {
  padding-left: 0;
  padding-right: 0;
}

.doc-page {
  padding-left: 0;
  padding-right: 90px;
}

.img-with-border {
  border: solid;
  padding: 1px;
  border-radius: 10%;
  width: 25px;
  margin-left: 10px;
  margin-right: 2px;
  color: lightgray;
}

.reset-icon {
  width: 1em;
  height: 1em;
  font-size: 1.5em;
  color: tomato;
  margin-left: 2px;
  margin-right: 2px;
}

.star-excellent-conf {
  color: gold;
  margin-left: 4px;
  /* Trick to align the star to the text */
  margin-bottom: 4px;
}

.star-good-conf {
  color: silver;
  margin-left: 4px;
  /* Trick to align the star to the text */
  margin-bottom: 4px;
}

.isoarrow {
  padding-left: 2px;
  padding-right: 2px;
}

.img-with-viz:hover {
  cursor: pointer;
}

.score {
  margin-left: 5px;
  color: gray;
}

.img-footer {
  margin-left: 15px;
  padding-left: 15px;
}

.eppic-help-img {
  float: left;
  width: 500px;
  margin-right: 25px;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overscroll-behavior: none;
}

.top-nav {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.main-container {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.left-nav-col {
  padding-right: 0;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  overscroll-behavior: none;
}

.main-content-col {
  overflow-y: auto;
  height: 100vh;
  overscroll-behavior: none;
}

.sticky-header {
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.processing-alert {
  padding-top: 10px;
}

.welcome-message {
  padding-top: 40px;
}

.assembly-table-container {
  padding-bottom: 100px;
}`, "",{"version":3,"sources":["webpack://./src/client/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ,uCAAuC;AACvC;EACE,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,cAAc;EACd,oBAAoB;AACtB;;AAEA,qDAAqD;AACrD;;;;;;;;;;;CAWC;;AAED;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* App.css */\n\n/* Added to prevent overscroll bounce */\nhtml, body {\n  overscroll-behavior: none;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n/* Optional: Additional classes for convenience */\n.full-height {\n  height: 100vh;\n}\n\n.no-overscroll {\n  overscroll-behavior: none;\n}\n\n.no-overflow {\n  overflow: hidden;\n}\n\n/* Existing styles */\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 40vmin;\n  pointer-events: none;\n}\n\n/* You can uncomment and use these styles if needed */\n/*\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n*/\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.container-fluid {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.doc-page {\n  padding-left: 0;\n  padding-right: 90px;\n}\n\n.img-with-border {\n  border: solid;\n  padding: 1px;\n  border-radius: 10%;\n  width: 25px;\n  margin-left: 10px;\n  margin-right: 2px;\n  color: lightgray;\n}\n\n.reset-icon {\n  width: 1em;\n  height: 1em;\n  font-size: 1.5em;\n  color: tomato;\n  margin-left: 2px;\n  margin-right: 2px;\n}\n\n.star-excellent-conf {\n  color: gold;\n  margin-left: 4px;\n  /* Trick to align the star to the text */\n  margin-bottom: 4px;\n}\n\n.star-good-conf {\n  color: silver;\n  margin-left: 4px;\n  /* Trick to align the star to the text */\n  margin-bottom: 4px;\n}\n\n.isoarrow {\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n.img-with-viz:hover {\n  cursor: pointer;\n}\n\n.score {\n  margin-left: 5px;\n  color: gray;\n}\n\n.img-footer {\n  margin-left: 15px;\n  padding-left: 15px;\n}\n\n.eppic-help-img {\n  float: left;\n  width: 500px;\n  margin-right: 25px;\n}\n\n.app-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overscroll-behavior: none;\n}\n\n.top-nav {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.main-container {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n.left-nav-col {\n  padding-right: 0;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n  overscroll-behavior: none;\n}\n\n.main-content-col {\n  overflow-y: auto;\n  height: 100vh;\n  overscroll-behavior: none;\n}\n\n.sticky-header {\n  background-color: white;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.processing-alert {\n  padding-top: 10px;\n}\n\n.welcome-message {\n  padding-top: 40px;\n}\n\n.assembly-table-container {\n  padding-bottom: 100px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
